import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import { Badge, Box, Button, Card, Grid, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { helpers } from "~/lib/helpers";
const ScrollableTable = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 300px;
  width: 100%;
  margin: 0 -8px 0 -8px;
`;
const StyledCell = styled(Grid.Cell)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const StyledBox = styled(Box)`
  position: relative;
  border: 1px solid ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.borders.primary;
}};
`;
const TopicTrendRevenueCard = _ref2 => {
  let {
    revenue,
    ...rest
  } = _ref2;
  const {
    t
  } = useTranslation();
  const records = Array.isArray(revenue?.records) ? revenue?.records : [];
  const activityLimit = 3;
  const [expandedExisting, setExpandedExisting] = useState(false);
  const displayedExistingRecords = expandedExisting ? records : records?.slice(0, activityLimit);
  return /*#__PURE__*/React.createElement(Card, _extends({
    fullWidth: true
  }, rest), /*#__PURE__*/React.createElement(StyledBox, {
    s: {
      p: 4,
      pr: 2,
      mb: 6
    },
    rounded: true
  }, /*#__PURE__*/React.createElement(Box, {
    s: {
      mb: 4,
      pr: 1
    },
    fullWidth: true,
    justify: "space-between",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    display: "inline",
    element: "h4"
  }, t("TopicTrendRevenueCard.mappedRevenue")), /*#__PURE__*/React.createElement(Badge, {
    color: "primaryAccentContrast",
    display: "inline",
    fontSize: 4,
    weight: "bold",
    style: {
      float: "right"
    },
    s: {
      ml: 4,
      mt: -1,
      py: 1.5,
      px: 4
    }
  }, revenue?.total)), /*#__PURE__*/React.createElement(ScrollableTable, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 1,
    gap: 0,
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "2.5fr 1.5fr 1fr",
    s: {
      p: 2
    },
    gap: 2,
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    fontSize: 3
  }, t("TopicTrendRevenueCard.name"))), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    fontSize: 3
  }, t("TopicTrendRevenueCard.type"))), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    fontSize: 3
  }, t("TopicTrendRevenueCard.amount")))), displayedExistingRecords?.map(record => /*#__PURE__*/React.createElement(Grid, {
    key: record.id,
    cols: 3,
    s: {
      p: 2
    },
    gap: 2,
    color: "text",
    template: "2.5fr 1.5fr 1fr",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(StyledCell, null, /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-html": `<div>${record?.name}</div>`
  }, record?.name)), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    weight: "medium"
  }, record?.type === "opportunity" ? t("TopicTrendRevenueCard.opportunity") : t("TopicTrendRevenueCard.account"))), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    weight: "medium"
  }, record?.amount > 0 ? `${record?.currency}${helpers.formatMoneyAmount(record.amount).toLocaleString()}` : "-")))))), records && records.length > activityLimit && /*#__PURE__*/React.createElement(Button, {
    onClick: e => {
      e.stopPropagation();
      setExpandedExisting(!expandedExisting);
    },
    color: "translucent",
    display: "block",
    fontSize: 3.5,
    s: {
      py: 2,
      px: 4,
      mt: 3
    },
    outline: false,
    textAlign: "center",
    fullWidth: true
  }, expandedExisting ? t("TopicTrendRevenueCard.showLess") : t("TopicTrendRevenueCard.showAll", {
    count: records.length - activityLimit
  }))));
};
export default TopicTrendRevenueCard;